
import CaptureHealthDetailsAS from './capture-details/health/Arogya Sanjeevani';
import CaptureHealthDetailsCI from './capture-details/health/Critical Illness';
import CaptureHealthDetailsST from './capture-details/health/Super Top Up';
import NewPolicyIssuanceST from './new-policy-issuance/health/Super Top Up';
import CaptureHealthDetailsSCPA from './capture-details/health/SCPA';
import CaptureCarSecureDetails from './capture-details/motor/carSecure';
import { QUOTES, PROPOSAL } from 'quanta-flows/modules/permissions';
import { RENEW_POLICY ,READ_POLICY } from 'quanta-flows/modules/permissions';
import NewMotorPolicyIssuanceSCPA from './capture-details/health/two-wheeler';
import NewMotorPolicyIssuanceCarSecure from'./new-policy-issuance/motor/carSecure';
import CaptureFireDetailsSF from './capture-details/fire/Standalone Fire';
// import {ViewRenewPolicy} from './view-renew-policy';
import ViewRenewPolicy from '../policy/view-renew-policy';
import ViewPolicy from '../policy/view-policy';
import ViewQuoteDetails from './view-quote-details';
import ViewProposalDetails from './view-proposal-details'
import ViewQuoteDetailsSF from './view-quote-details';
import NewFirePolicyIssuanceSA from './new-policy-issuance/fire/Standalone Fire';
import CaptureGCVDetails from './capture-details/GVC/GCV';
import NewMotorPolicyIssuanceGCV from'./new-policy-issuance/motor/GCV';
import CapturePCVDetails from './capture-details/PCV/PCV';
import NewMotorPolicyIssuancePCV from'./new-policy-issuance/motor/PCV'; 
import CaptureMISCDDetails from './capture-details/MISCD/MISCD';
import NewMotorPolicyIssuanceMISCD from'./new-policy-issuance/motor/MISCD'; 
// const ViewRenewPolicy = lazy(() => import('./view-renew-policy'));advisor-ui\packages\ui-alpha\src\modules\policy
/*SAMOD */
import ModifyProposalDetails from './modify-proposal-details'; 
/*EAMOD */
// const Route = [

//   { 
//     secure: true,
//     exact: true,
//     permission: RENEW_POLICY,
//     path:
//        '/policy/renew/:customerID/2880/Kotak Health Super Top Up/:proposal_number/:renewal_mode',
//       //  '/policy/renew/:customerID/:product_code/:product_name/:proposal_number/:renewal_mode',
//        props: {
//         // lobCode: '28',
//          product_name: 'Kotak Health Super Top Up',
//         product_code: '2880',
        
//       },
//     component: ViewRenewPolicy,
    
//   },
// ];

const Route = [
  {
    secure: true,
    exact: true,
    permission: QUOTES,
    // path: '/quote/Health/28/Critical Illness/2877',
    path:'/quote/Health/:lob_code/:product_name/2877',
    component: CaptureHealthDetailsCI,
    props: {
      lobCode: '28',
      // productName: 'Kotak Secure Shield',
      productCode: '2877',
    },
  },
  {
    secure: true,
    exact: true,
    permission: QUOTES,
    // path: '/quote/Health/28/Kotak Aarogya Sanjeevani/2885',
    path:'/quote/Health/:lob_code/:product_name/2885',
    component: CaptureHealthDetailsAS,
    props: {
      lobCode: '28',
      // productName: 'Aarogya Sanjeevani',
      // productName:'Arogya Sanjeevani Policy, Kotak Mahindra General Insurance Company Ltd',
      // productName: 'Kotak Aarogya Sanjeevani',
      productCode: '2885',
    },
  },
  {
    secure: true,
    exact: true,
    permission: QUOTES,
    // path: '/quote/Health/28/Kotak Health Super Top Up/2880',
    path:'/quote/Health/:lob_code/:product_name/2880',

    component: CaptureHealthDetailsST,
    props: {
      lobCode: '28',
      // productName: 'Super Top Up',
      // productName: 'Kotak Health Super Top Up',
      productCode: '2880',
    },
  },
  {
    secure: true,
    exact: true,
    permission: PROPOSAL,
    path: '/quote/health/buy/28/:product_name/2880/:plan_code/:plan_name',
    props: {
      lobCode: '28',
      // productName: 'Super Top Up',
      // productName: 'Kotak Health Super Top Up',
      productCode: '2880',
    },
    component: NewPolicyIssuanceST,
  },
  {
    secure: true,
    exact: true,
    permission: QUOTES,
    path: '/quote/motor/31/:product_name/3153',
    component: CaptureHealthDetailsSCPA,
    props: {
      lobCode: '31',
      // productName: 'Kotak Compulsory Personal Accident - Owner-Driver',
      productCode: '3153',
    },
  },
  {
    secure: true,
    exact: true,
    permission: PROPOSAL,
    path: '/quote/motor/buy/31/:product_name/3153/:plan_code/:plan_name',
    //'/quote/motor/buy/28/:product_name/3153/:product_type',
    props: {
      lobCode: '31',
      // productName: 'Kotak Compulsory Personal Accident - Owner-Driver',
      productCode: '3153',
    },
    component: NewMotorPolicyIssuanceSCPA,
  },
  {
    secure: true,
    exact: true,
    permission: RENEW_POLICY,
    path: '/policy/renew/:customerID/2880/:product_name/:proposal_number/:renewal_mode/:rcStatus/:modify',
    props: {
      lobCode: '28',
      // product_name: 'Kotak Health Super Top Up',
      product_code: '2880',
    },
    component: ViewRenewPolicy,
  },
  {
    secure: true,
    exact: true,
    permission: RENEW_POLICY,
    path: '/uipolicy/renew/:customerID/:product_code/:product_name/:proposal_number/:renewal_mode/:rcStatus/:modify',
    component: ViewRenewPolicy,
  },
  {
    secure: true,
    exact: true,
    permission: QUOTES,
    path: '/quote/Motor/31/Car Insurance/:product_code',
    component: CaptureCarSecureDetails,
    props: {
      lobCode: '31',
      productName: 'Car Insurance',
    },
  },
  {
    secure: true,
    exact: true,
    permission: PROPOSAL,
    path: '/quote/motor/buy/31/Car Insurance/:product_code/:product_type',
    props: {
      lobCode: '31',
      productName: 'Car Insurance',
      // productCode: '3121', 
    },
    component: NewMotorPolicyIssuanceCarSecure,
  },
  {
    secure: true,
    exact: true,
    permission: QUOTES,
    //path: '/quote/fire/11/standalone fire/1132',
    path: '/quote/Fire/:lob_code/:product_name/1132',
    
    props: {
       //lobCode: '11',
      //product_name: 'Standalone Fire',
      product_code: '1132',
      
  },
  component: CaptureFireDetailsSF,
  
},
   
  {
    secure: true,
    exact: true,
    permission: QUOTES,
    path: '/uiquote/saved/:lob_code/:lob_name/:product_code/:product_name/:quote_number',
    component: ViewQuoteDetails,
  },
   {
    secure: true,
    exact: true,
    permission: PROPOSAL,
    path: '/uiproposal/saved/:customerID/:lob_code/:lob_name/:product_code/:product_name/:proposal_number',
    component: ViewProposalDetails,
  },
   {
  secure: true,
  exact: true,
  permission: QUOTES,
  path:
    '/quote/saved/:lob_code/:lob_name/1132/:product_name/:quote_number',
    props: {
      //lobCode: '11',
     //product_name: 'Standalone Fire',
     product_code: '1132',
 },
 component: ViewQuoteDetailsSF,
},
  {
  secure: true,
  exact: true,
  permission: PROPOSAL,
  path: '/quote/Fire/buy/11/:product_name/1132/',
  props: {
    lobCode: '11',
    // productName: 'Super Top Up',
    // productName: 'Kotak Bharat Griha Raksha',
    productCode: '1132',
  },
  component: NewFirePolicyIssuanceSA,
  },
  {
  secure: true,
  exact: true,
  permission: QUOTES,
  path: '/quote/Motor/31/GCV/:product_code',
  component: CaptureGCVDetails,
  props: {
    lobCode: '31',
    productName: 'GCV',
  },
},
{
  secure: true,
  exact: true,
  permission: PROPOSAL,
  path: '/quote/motor/buy/31/GCV/:product_code',
  props: {
    lobCode: '31',
    productName: 'GCV',
    // productCode: '3121', 
  },
  component: NewMotorPolicyIssuanceGCV,
},
{
  secure: true,
  exact: true,
  permission: QUOTES,
  path: '/quote/Motor/31/PCV/:product_code',
  component: CapturePCVDetails,
  props: {
    lobCode: '31',
    productName: 'PCV',
  },
},
{
  secure: true,
  exact: true,
  permission: PROPOSAL,
  path: '/quote/motor/buy/31/PCV/:product_code',
  props: {
    lobCode: '31',
    productName: 'PCV',
    // productCode: '3121', 
  },
  component: NewMotorPolicyIssuancePCV,
},
{
  secure: true,
  exact: true,
  permission: QUOTES,
  path: '/quote/Motor/31/MISCD/:product_code',
  component: CaptureMISCDDetails,
  props: {
    lobCode: '31',
    productName: 'MISCD',
  },
},
{
  secure: true,
  exact: true,
  permission: PROPOSAL,
  path: '/quote/motor/buy/31/MISCD/:product_code',
  props: {
    lobCode: '31',
    productName: 'MISCD',
    // productCode: '3121', 
  },
  component: NewMotorPolicyIssuanceMISCD,
},
{
  secure: true,
  exact: true,
  permission: READ_POLICY,
  path: '/uipolicy/view/:lob_code/:lob_name/:customer_id/:proposal_no/:policy_no',
  component: ViewPolicy,
},
  //SAMOD
  {
    secure: true,
    exact: true,
    permission: QUOTES,
    path: '/quote/uisaved/:lob_code/:lob_name/:product_code/:product_name/:quote_number/:proposal_number/:modify',
    component: ModifyProposalDetails,
  },
  //EAMOD
];

export default Route;
